/* ZT - Kirlune PawPro: galeria, carruseles, barra pegajosa y comparador.
   Sin dependencias. Solo actua sobre elementos con prefijo zt-.            */
(function () {
  'use strict';

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------- carrusel generico basado en scroll-snap ------------------ */
  function initCarousel(root, opts) {
    var track = root.querySelector('[data-zt-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    if (!slides.length) return;
    var dots = root.querySelectorAll('[data-zt-dot]');
    var thumbs = root.querySelectorAll('[data-zt-thumb]');
    var counter = root.querySelector('[data-zt-counter]');
    var current = 0;

    function goTo(i) {
      current = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[current].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      sync();
    }

    function sync() {
      for (var d = 0; d < dots.length; d++) dots[d].setAttribute('aria-current', d === current ? 'true' : 'false');
      for (var t = 0; t < thumbs.length; t++) thumbs[t].setAttribute('aria-current', t === current ? 'true' : 'false');
      if (counter) counter.textContent = current + 1;
    }

    var raf;
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var mid = track.scrollLeft + track.clientWidth / 2;
        var best = 0, bestDist = Infinity;
        for (var i = 0; i < slides.length; i++) {
          var c = slides[i].offsetLeft - track.offsetLeft + slides[i].clientWidth / 2;
          var dist = Math.abs(c - mid);
          if (dist < bestDist) { bestDist = dist; best = i; }
        }
        if (best !== current) { current = best; sync(); }
      });
    }, { passive: true });

    var prev = root.querySelector('[data-zt-prev]');
    var next = root.querySelector('[data-zt-next]');
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    for (var d2 = 0; d2 < dots.length; d2++) {
      (function (i) { dots[i].addEventListener('click', function () { goTo(i); }); })(d2);
    }
    for (var t2 = 0; t2 < thumbs.length; t2++) {
      (function (i) { thumbs[i].addEventListener('click', function () { goTo(i); }); })(t2);
    }

    if (opts && opts.autoplay) {
      var paused = false;
      root.addEventListener('pointerenter', function () { paused = true; });
      root.addEventListener('pointerleave', function () { paused = false; });
      setInterval(function () {
        if (paused) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        goTo(current + 1 >= slides.length ? 0 : current + 1);
      }, opts.autoplay);
    }

    sync();
  }

  /* ---------- barra pegajosa de compra ---------------------------------- */
  function initSticky() {
    var bar = document.querySelector('[data-zt-sticky]');
    if (!bar) return;
    var trigger = document.querySelector('[data-zt-sticky-trigger]');
    if (!trigger) return;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          bar.classList.toggle('is-visible', e.boundingClientRect.top < 0 && !e.isIntersecting);
        });
      }, { threshold: 0 }).observe(trigger);
    }
  }

  /* ---------- comparador antes / despues -------------------------------- */
  function initCompare() {
    var nodes = document.querySelectorAll('[data-zt-compare]');
    for (var i = 0; i < nodes.length; i++) {
      (function (box) {
        var input = box.querySelector('[data-zt-compare-input]');
        if (!input) return;
        var apply = function () { box.style.setProperty('--zt-pos', input.value + '%'); };
        input.addEventListener('input', apply);
        apply();
      })(nodes[i]);
    }
  }

  onReady(function () {
    var gal = document.querySelector('[data-zt-gallery]');
    if (gal) initCarousel(gal, null);
    var mini = document.querySelector('[data-zt-mini]');
    if (mini) initCarousel(mini, { autoplay: 4000 });
    var revs = document.querySelectorAll('[data-zt-reviews]');
    for (var i = 0; i < revs.length; i++) initCarousel(revs[i], null);
    initSticky();
    initCompare();
  });
})();
